module.exports = __webpack_public_path__ + "img/253-539d18.png";